module.exports = __webpack_public_path__ + "static/media/3.2ca7389b.jpg";